export default "__VITE_ASSET__BP6x7RBh__"